// extracted by mini-css-extract-plugin
export default {"about":"Team_about__MnAAN","bio":"Team_bio__WYAWT","slider":"Team_slider__Cowm2"};